module.exports = __webpack_public_path__ + "img/logo-min.2c7b8ecc.jpg";